import { render, staticRenderFns } from "./expertable.vue?vue&type=template&id=06ae0110"
import script from "./expertable.vue?vue&type=script&lang=js"
export * from "./expertable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports